"use client";
import { createContext, ReactNode, useContext, useState, useCallback } from "react";

interface VideoModalContextType {
  isVideoModalOpen: boolean;
  openVideoModal: () => void;
  closeVideoModal: () => void;
}

const VideoModalContext = createContext<VideoModalContextType | undefined>(
  undefined
);

export function VideoModalProvider({ children }: { children: ReactNode }) {
  const [openModalsCount, setOpenModalsCount] = useState(0);

  const openVideoModal = useCallback(() => {
    setOpenModalsCount(prev => prev + 1);
  }, []);

  const closeVideoModal = useCallback(() => {
    setOpenModalsCount(prev => Math.max(0, prev - 1));
  }, []);

  const isVideoModalOpen = openModalsCount > 0;

  return (
    <VideoModalContext.Provider
      value={{ isVideoModalOpen, openVideoModal, closeVideoModal }}
    >
      {children}
    </VideoModalContext.Provider>
  );
}

export function useVideoModal() {
  const context = useContext(VideoModalContext);
  if (!context) {
    throw new Error("useVideoModal must be used within a VideoModalProvider");
  }
  return context;
}

